import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

const styles = theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
    textAlign: "center",
    height: "100%",
    backgroundImage: `url("/images/welcome.jpg")`,
    backgroundPosition: "center bottom",
    backgroundSize: "cover"
  },
  vertrekButton: {
    padding: "1em"
  },
  title: {
    color: theme.palette.common.white
  },
  body: {
    // backgroundColor: "white",
    // padding: ".2em",
    color: theme.palette.common.white,
    width: "80%",
    marginBottom: "20vh"
  }
});

class Welcome extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="title" className={classes.title} gutterBottom>
          Klaar om te fietsen?
        </Typography>
        <Typography variant="body1" className={classes.body} gutterBottom>
          Ontdek mooie fietsroutes en test de fiets-app van VRT Innovatie. Kies
          hoeveel km jij wil fietsen, of je kassei- en/of zandwegen wilt
          vermijden en de app berekent voor jou een route langs het
          knooppuntennetwerk. Of ben je benieuwd naar welke route onze
          ambassadeurs aanbevelen? Neem een kijkje! Meer zelfs, op specifieke
          knooppunten kan je exclusieve historische VRT-fragmenten bekijken over
          de streek waar je fietst. Vertrekken maar!
        </Typography>
        <Link to="/eigenroute">
          <Button
            size="large"
            variant="raised"
            color="primary"
            className={classes.vertrekButton}
            // onClick={() => onClick(value)}
          >
            Vertrek
          </Button>
        </Link>
      </div>
    );
  }
}

export default withStyles(styles)(Welcome);



// WEBPACK FOOTER //
// ./src/components/Welcome.js